import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Box from '../components/Box'
import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'
import Calendar from '../components/Calendar'; // Import the Calendar component
import { fetchCalendar } from '../actions/calendars'
import { fetchCustomer } from '../actions/customers'
import CalendarPricesAddForm from '../forms/CalendarPricesAddForm'

class CalendarDetailsView extends React.Component {
  constructor(props) {
    super(props);
    const currentYear = new Date().getFullYear();
    this.state = {
      startMonth: 10,
      endMonth: 3,
      startYear: currentYear,
      endYear: currentYear,
      minYear: currentYear,
      maxYear: currentYear,
    };
  }

  componentDidMount() {
    const { fetchCalendar, fetchCustomer } = this.props;

    fetchCalendar(this.props.match.params.id).then(response => {

      fetchCustomer(response.response.Customer);
    });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.calendar &&
      this.props.calendar.PriceCalendar &&
      prevProps.calendar?.PriceCalendar !== this.props.calendar.PriceCalendar &&
      this.props.calendar.PriceCalendar.length > 0
    ) {
      const dates = this.props.calendar.PriceCalendar.map(entry => new Date(entry.date));

      const minDate = new Date(Math.min(...dates));
      const maxDate = new Date(Math.max(...dates));

      const minYear = minDate.getFullYear();
      const maxYear = maxDate.getFullYear();

      this.setState({
        startMonth: minDate.getMonth(),  // 0 = January
        endMonth: maxDate.getMonth(),     // 11 = December
        startYear: minYear,
        endYear: maxYear,
        minYear: minYear,
        maxYear: maxYear,
      });
    }
  }

  handleMonthChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: parseInt(value) });
  };

  handleYearChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: parseInt(value) });
  };

  render() {
    const { calendar, error, loading } = this.props;
    const { startMonth, endMonth, startYear, endYear, minYear, maxYear } = this.state;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!calendar || loading) {
      return <LoadingProgress />;
    }

    const monthNames = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    // Generate array of years from minYear to maxYear
    const availableYears = [];
    for (let year = minYear; year <= maxYear; year++) {
      availableYears.push(year);
    }

    return (
      <div>
        <div className="row mb-2">
          <div className="col">
            <h1>
              <span className="text-vw-light">CALENDARIO  </span>
              <span className="text-vw-dark">{calendar.Name}</span>
            </h1>
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-xs-12 col-sm-2 col-md-2">
            <Box title="Meses a mostrar" icon="calendar-alt">
              <div className="mt-3 mb-1">
                <div className="col mb-3">
                  <h6 className="text-dark">Mes de Inicio</h6>
                  <div className="row">
                    <div className="col-7 pr-1">
                      <select className="form-control false" name="startMonth" value={startMonth} onChange={this.handleMonthChange}>
                        {monthNames.map((monthName, index) => (
                          <option key={index} value={index}>{monthName}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-5 pl-1">
                      <select className="form-control false" name="startYear" value={startYear} onChange={this.handleYearChange}>
                        {availableYears.map((year) => (
                          <option key={year} value={year}>{year}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <h6 className="text-dark">Mes de Fin</h6>
                  <div className="row">
                    <div className="col-7 pr-1">
                      <select className="form-control false" name="endMonth" value={endMonth} onChange={this.handleMonthChange}>
                        {monthNames.map((monthName, index) => (
                          <option key={index} value={index}>{monthName}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-5 pl-1">
                      <select className="form-control false" name="endYear" value={endYear} onChange={this.handleYearChange}>
                        {availableYears.map((year) => (
                          <option key={year} value={year}>{year}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          </div>
          <div className="col-xs-12 col-sm-10 col-md-10">
            <Box title="Formulario de actualización de precios" icon="calendar-alt">
              <CalendarPricesAddForm
                customer={this.props.customer}
                calendar={calendar}
              />
            </Box>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Calendar
              startYear={startYear}
              endYear={endYear}
              priceCalendar={calendar.PriceCalendar}
              startMonth={startMonth}
              endMonth={endMonth}
              customer={this.props.customer}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  calendar: state.calendars.calendar,
  customer: state.customers.customer,
  loading: state.calendars.loading,
  error: state.calendars.error,
});

const mapDispatchToProps = dispatch => ({
  fetchCalendar: bindActionCreators(fetchCalendar, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarDetailsView);
